module.exports = __webpack_public_path__ + "static/media/workflow2.bac5598d.svg";